module.exports = __webpack_public_path__ + "static/media/bg-iphone-2.a71debfc.png";